const GUEST_MODE_KEY = 'guestMode';
const GUEST_SESSION_KEY = 'guestSessionId';
const DEBUG_MOCK_USER_KEY = 'debugMockUser';

export const enableGuestMode = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(DEBUG_MOCK_USER_KEY);
    window.localStorage.removeItem('persist:admin-app');
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('access_token');
    window.localStorage.setItem(GUEST_MODE_KEY, 'true');
    window.dispatchEvent(new Event('guestModeChanged'));
  }
};

export const disableGuestMode = () => {
  if (typeof window !== 'undefined') {
    // Ne retirer QUE le flag invité et le mock debug. Ne pas toucher au
    // token / access_token / persist:admin-app : sortir du mode invité
    // ne doit pas déconnecter un utilisateur authentifié (sinon un simple
    // refresh sur une page qui appelle disableGuestMode() le déconnecte).
    window.localStorage.removeItem(GUEST_MODE_KEY);
    window.localStorage.removeItem(DEBUG_MOCK_USER_KEY);
    window.dispatchEvent(new Event('guestModeChanged'));
  }
};

export const getGuestSessionId = () => {
  if (typeof window === 'undefined') return 'default';
  try {
    let sid = window.localStorage.getItem(GUEST_SESSION_KEY);
    if (!sid) {
      sid = `guest_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      window.localStorage.setItem(GUEST_SESSION_KEY, sid);
    }
    return sid;
  } catch (e) {
    return 'default';
  }
};

export const isGuestMode = () => {
  if (typeof window === 'undefined') return false;
  
  // Si l'utilisateur a un token, il n'est PAS en mode guest
  const token = window.localStorage.getItem('token');
  if (token) {
    // Nettoyer le flag guest si présent (l'utilisateur s'est connecté)
    const hadGuestFlag = window.localStorage.getItem(GUEST_MODE_KEY) === 'true';
    if (hadGuestFlag) {
      window.localStorage.removeItem(GUEST_MODE_KEY);
      window.dispatchEvent(new Event('guestModeChanged'));
    }
    return false;
  }
  
  const guestModeStorage = window.localStorage.getItem(GUEST_MODE_KEY) === 'true';
  if (guestModeStorage) return true;
  const query = new URLSearchParams(window.location.search);
  const guestParam = query.get('guest') === 'true';
  if (guestParam) {
    window.localStorage.setItem(GUEST_MODE_KEY, 'true');
    window.dispatchEvent(new Event('guestModeChanged'));
    return true;
  }
  // Pas de token = pas connecté = mode guest automatique
  return true;
};

export const enableDebugMockUser = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(DEBUG_MOCK_USER_KEY, 'true');
  }
};

export const disableDebugMockUser = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(DEBUG_MOCK_USER_KEY);
  }
};

export const isDebugMockUser = () => {
  if (typeof window === 'undefined') return false;
  return process.env.REACT_APP_DEBUG_MOCK_USER === 'true' && window.localStorage.getItem(DEBUG_MOCK_USER_KEY) === 'true';
};
